import { io, Socket } from 'socket.io-client';
import { API_URL } from '../constants';

class SocketService {
  private socket: Socket | null = null;
  private userId: string | null = null;

  connect(userId: string) {
    if (this.socket?.connected && this.userId === userId) {
      return this.socket;
    }

    if (this.socket) {
      this.disconnect();
    }

    this.socket = io(API_URL, {
      transports: ['websocket', 'polling'],
    });

    this.userId = userId;

    this.socket.on('connect', () => {
      console.log('Connected to WebSocket server');
      // Join user room for notifications
      this.socket?.emit('join', userId);
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected from WebSocket server');
    });

    this.socket.on('connect_error', (error) => {
      console.error('WebSocket connection error:', error);
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.userId = null;
    }
  }

  getSocket() {
    return this.socket;
  }

  isConnected() {
    return this.socket?.connected || false;
  }

  // Subscribe to new posts
  onNewPost(callback: (data: any) => void) {
    this.socket?.on('newPost', callback);
  }

  // Subscribe to public posts
  onNewPublicPost(callback: (data: any) => void) {
    this.socket?.on('newPublicPost', callback);
  }

  // Remove listeners
  offNewPost(callback?: (data: any) => void) {
    if (callback) {
      this.socket?.off('newPost', callback);
    } else {
      this.socket?.off('newPost');
    }
  }

  offNewPublicPost(callback?: (data: any) => void) {
    if (callback) {
      this.socket?.off('newPublicPost', callback);
    } else {
      this.socket?.off('newPublicPost');
    }
  }
}

const socketService = new SocketService();
export default socketService;